/** Minimal fields needed to distinguish Van der Valk on-roof vs flat-roof mode. */
export type VanDerValkMountingModeContext =
  | {
      mounting?: string | null
      mounting_type?: string | null
    }
  | null
  | undefined

export const VANDERVALK_FLAT_ROOF_FEATURE_FLAG = 'mounting_vandervalk_flat_roof'
export const VANDERVALK_PITCHED_ROOF_FEATURE_FLAG = 'mounting_vandervalk_pitched_roof'

export function isVanDerValkOnRoofMounting(system: VanDerValkMountingModeContext): boolean {
  return system?.mounting === 'vanDerValk' && system?.mounting_type === 'onRoof'
}

export function isVanDerValkFlatRoofMounting(system: VanDerValkMountingModeContext): boolean {
  return system?.mounting === 'vanDerValk' && !isVanDerValkOnRoofMounting(system)
}

export function getVanDerValkFeatureFlag(mountingSystemType?: string | null): string {
  return mountingSystemType === 'onRoof' ? VANDERVALK_PITCHED_ROOF_FEATURE_FLAG : VANDERVALK_FLAT_ROOF_FEATURE_FLAG
}

export function isVanDerValkFeatureEnabledForMountingType(
  mountingSystemType: string | null | undefined,
  isFeatureEnabled: (featureFlagName: string, targetValue?: string) => boolean | undefined
): boolean {
  return isFeatureEnabled(getVanDerValkFeatureFlag(mountingSystemType), 'on') === true
}
